/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { SxProps, Theme } from "@mui/material";
import { DetailedHTMLProps, HTMLAttributes } from "react";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import IconButtonLegalbird from "@/src/components/legalbird/IconButtonLegalbird/IconButtonLegalbird";
import ErrorIcon from "@mui/icons-material/Error";
import { mergeSx } from "@/src/utils/mergeSx";
import { burgerButtonStyle } from "@/src/components/Header/BurgerButton/burgerButtonStyle";
import { useBasicAccountData } from "@/src/provider/BasicAccountData/BasicAccountDataProvider";

export type BurgerButtonProps = {
  onClick: () => void;
  active?: boolean;
  sx?: SxProps<Theme>;
} & DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export default function BurgerButton({ onClick, active, sx }: BurgerButtonProps) {
  const { newMessages, inquiries } = useBasicAccountData();

  const needsAttention = !!(newMessages?.length || inquiries?.length);

  return (
    <IconButtonLegalbird
      label={active ? "Mobiles Menü schließen" : "Mobiles Menü öffnen"}
      variant={"text"}
      sx={mergeSx(burgerButtonStyle.burgerButton, sx)}
      onClick={onClick}
      aria-expanded={active}
    >
      {active ? <CloseIcon color={"primary"} /> : <MenuIcon color={"primary"} />}
      {needsAttention && <ErrorIcon sx={burgerButtonStyle.needsAttention} color={"warning"} fontSize={"small"} />}
    </IconButtonLegalbird>
  );
}
